import montaMensagem from './montaMensagem'
import montaMensagemContato from './montaMensagemContato'

export default {
	montaMensagem,
	montaMensagemContato,
}
